export default __webpack_public_path__ + "static/media/two_.af940eea.jpeg";